var stickyKcFaqs = {
    heightHeader: function() {
        var sticky = new Sticky('[data-sticky]', {});
    },
    anclaAside: function() {
        let headerHeightAncla = $('.c-site-header').height() + 47 ;
        $('.c-kc-faqs-aside__control-link').attr('href', '#c-kc-faqs-aside');
        $('.c-kc-faqs-aside').attr('id', 'c-kc-faqs-aside');
    },

}

$(function() {

    if ($('.c-kc-faqs').length) {
        //stickyKcFaqs.heightHeader();
        stickyKcFaqs.anclaAside();
    }
    if ($('.c-legal').length) {
        stickyKcFaqs.heightHeader();

    }
})


